<template>
  <div class="ColorCard"
       :style="{
          background: 'linear-gradient(to right, '+pcolor.blcolor+', '+pcolor.brcolor+')'}">
    <div class="box">
      <span :style="{color: pcolor.color}">{{pdata[0]}}</span>
    </div>
    <div class="box">
      <span>{{pdata[1]}}</span>
    </div>
    <div class="mask">
    </div>
  </div>
</template>

<script>

export default {
  name: "ColorCard",
  props:["pdata","pcolor"],

}
</script>

<style lang="scss" scoped>
.ColorCard{
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-around;
  width: 310px;
  height: 120px;
  box-shadow: $boxshadow;
  overflow: hidden;
  .box{
    position: relative;
    z-index: 3;
    margin-top:15px;
    span:nth-of-type(1){
      line-height:80px;
      font-size: 51px;
      font-weight: bold;
      
    }
    &:nth-of-type(2){
        span{
    font-size: 32px !important;
      color: #fff;
        }
  
    }
  }
  .mask{
    position: absolute;
    z-index: 2;
    top: -140px;
    left: -80px;
    width: 240px;
    height: 270px;
    border-radius: 50%;
    background-color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/map/cityList/ColorCard.vue